import { Link } from "react-router-dom";

const footerLinks = [
  { to: "/", label: "首页" },
  { to: "/movies", label: "电影分类" },
  { to: "/tvshows", label: "电视剧分类" },
  { to: "/search", label: "搜索影片" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-background-200/60 bg-gradient-to-b from-background-100 via-secondary-950 to-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                免费观看大片<span className="text-primary-500">在线观看</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              综合影视资源展示平台，聚焦最新热门电影与电视剧的介绍与检索，让每一位影视爱好者都能轻松找到想看的影片。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-500"></i>
              本站影视播放为前端功能演示，不提供真实流媒体播放与下载。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">
              <a href="/">快速导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">
              <a href="/">影视类型</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/movies" className="text-sm text-foreground-600 hover:text-primary-500">
                  动作科幻大片
                </Link>
              </li>
              <li>
                <Link to="/movies" className="text-sm text-foreground-600 hover:text-primary-500">
                  悬疑犯罪电影
                </Link>
              </li>
              <li>
                <Link to="/tvshows" className="text-sm text-foreground-600 hover:text-primary-500">
                  国产古装剧集
                </Link>
              </li>
              <li>
                <Link to="/tvshows" className="text-sm text-foreground-600 hover:text-primary-500">
                  都市家庭剧集
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 免费观看大片在线观看 · 内容仅供演示与学习参考</p>
          <p>本站不存储任何影视资源，版权归原作者所有。</p>
        </div>
      </div>
    </footer>
  );
}